module.exports = __webpack_public_path__ + "static/media/YF18_4.e71ac1a0.jpg";